(() => {
  if (window.shStorefrontReady) return;
  window.shStorefrontReady = true;
  const triggers = new WeakMap();
  const dialogs = '[data-sh-menu-dialog], [data-sh-search-dialog]';
  const syncLock = () => document.documentElement.classList.toggle('sh-lock-scroll', !!document.querySelector('dialog.sh[open]'));
  function close(dialog) { if (dialog?.open) dialog.close(); }
  function open(dialog, trigger) {
    if (!dialog?.showModal) return false;
    document.querySelectorAll(dialogs).forEach(other => { if (other !== dialog) close(other); });
    triggers.set(dialog, trigger);
    dialog.showModal();
    trigger?.setAttribute('aria-expanded', 'true');
    syncLock();
    if (dialog.matches('[data-sh-search-dialog]')) dialog.querySelector('input[type="search"]')?.focus();
    return true;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-sh-open-menu], [data-sh-open-search]');
    if (trigger) {
      const header = trigger.closest('[data-sh-header]');
      const selector = trigger.hasAttribute('data-sh-open-menu') ? '[data-sh-menu-dialog]' : '[data-sh-search-dialog]';
      if (open(header?.querySelector(selector), trigger)) event.preventDefault();
    }
    if (event.target.closest('[data-sh-close-dialog]')) close(event.target.closest('dialog'));
    if (event.target.matches('dialog.sh')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(event.target);
    }
    document.querySelectorAll('.sh-desktop-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sh-nav-details[open]').forEach(details => { details.open = false; });
  });
  function bind(scope) {
    scope.querySelectorAll(dialogs).forEach(dialog => {
      if (dialog.dataset.shBound) return;
      dialog.dataset.shBound = 'true';
      dialog.addEventListener('close', () => {
        const trigger = triggers.get(dialog);
        trigger?.setAttribute('aria-expanded', 'false');
        syncLock();
        if (trigger?.isConnected) trigger.focus();
      });
    });
  }
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', () => queueMicrotask(syncLock));
  window.matchMedia('(min-width:900px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll(dialogs).forEach(close);
  });
  bind(document);
})();
